import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { generateCSStats } from '../../actions/Accounting';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  RaisedButton,
  Snackbar,
  TextField,
} from 'material-ui';

const styles = {
  stats: {
    margin: 8,
    padding: 18
  },
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400
  },
  toggle: {
    marginBottom: 24,
    marginTop: 32,
    width: 200
  },
  status: {
    marginBottom: 32
  },
  flex1: { flex: 1 },
  flex: {
    display: 'flex',
  }
};

class CsStats extends Component {
  static propTypes = {
    generateCSStats: PropTypes.func,
  };

  state = {
    message: null,
    open: false,
    value: 'a',
    error: 'This field is mandatory',
    submit: true,
    idState: '',
    costState: '',
    percentageState: '',
    uniqueUsers: false,
    fromCircles: false,
    ucpData: false,
    uniqueUsersPermissions: false,
    status: 0,
    paymentStatus: 0,
    hidePurchases: false,
    paymentFormat: 0,
    emailsSelected: [],
  };

  handleGenerateCSStats = () => {
    const { generateCSStats } = this.props;

    const startDate = String(this.refs.startDateCoef.getValue()) || undefined;
    const endDate = String(this.refs.endDateCoef.getValue()) || undefined;

    generateCSStats({ startDate, endDate }).then(res => {
      if (!res.error) {
        this.setState({
          open: true,
          message: 'Data sent to your email'
        });
      } else {
        this.setState({
          open: true,
          message: 'Error: ' + res.data
        });
      }
    });
  };

  clearMessage = () => {
    this.setState({ message: null, open: false });
  };

  setUniqueUsers = () => {
    this.setState({ uniqueUsers: !this.state.uniqueUsers });
  };

  render() {
    const { message, open } = this.state;

    return (
      <div>
        <h2 style={styles.headline}>Generate CS Stats</h2>
        <TextField
          floatingLabelText='Start date'
          ref='startDateCoef'
          type='date'
        />
        <br />
        <TextField
          floatingLabelText='End date'
          ref='endDateCoef'
          type='date'
        />
        <br />
        <p>
          Pressing the following button, generates CS stats for the
          current month and sends an Excel file to you
                </p>
        <RaisedButton
          label={'Generate CS stats for the dates'}
          onClick={this.handleGenerateCSStats}
          style={{ marginLeft: 8 }}
          backgroundColor='#FFFAAE'>
          <Snackbar
            message={message || ''}
            open={!!open}
            autoHideDuration={3000}
            onRequestClose={this.clearMessage}
          />
        </RaisedButton>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    generateCSStats: bindActionCreators(generateCSStats, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    users: state.users.users,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CsStats);
